<div class="container-fluid col-xl-8 questionaireBg">
	<div class="card h-100">
		<div class="card-header d-flex justify-content-between" *ngIf="!showVideoUploading">
			<h4 class="fw-bold" [ngClass]="questionnaire.lang_code === 'he' ? 'ms-auto' : 'me-auto'"> 
				{{ showBaseline ? 'Baseline' : chapter_name }}
			</h4>
			<p *ngIf="showTimer" class="timer ms-auto my-auto">{{ formatTime(waitTimeout) }}</p>
			<div class="w-50 prog-wrapper d-flex justify-content-end mb-2">
				<div class="progItem mt-auto mb-auto" *ngFor="let count of counter(question_length); let i = index" [ngClass]="i <= question_index ? 'progItem-highlighted' : ''"></div>
			</div>
		</div>
		<div class="card-body questionaireSectionMain">
			<div *ngIf="!showVideoUploading">
				<div class="videoWrapper mt-1 w-100">
					<div class="ql-container ql-snow" style="border-width: 0;">
						<div *ngIf="sanitizedContent" class="ql-editor" [innerHTML]="sanitizedContent"></div>
						<div *ngIf="currentQuestion.body.link_type === 'VIDEO'" class="ratio ratio-16x9">
							<iframe [src]="safeUrl" allowfullscreen></iframe>
						</div>
						<div *ngIf="currentQuestion.body.link_type === 'AUDIO'" class="text-center">
							<audio controls>
								<source [src]="safeUrl" type="audio/mpeg">
								<source [src]="safeUrl" type="audio/aac">
								<source [src]="safeUrl" type="audio/mpeg">
								<source [src]="safeUrl" type="audio/ogg">
								The browser does not support the audio element.
							</audio>
						</div>
					</div>
				</div>
	
				<div class="rightSideBlock" *ngIf="currentQuestion.response.response_type && (currentQuestion.response.response_type !== 'VISUAL')">
					<div class="base pt-2 radioRemoveDisabled">
						<div class="row">
							<div class="d-flex gap-3 align-items-middle">
								<img src="../../../../../assets/images/svg/audio.svg" alt="test" class="icons-audio my-auto" *ngIf="currentQuestion.response.response_type === 'VOICE'" />
								<div class='d-flex flex-column'>
									<p class="title-margin title my-auto" *ngIf="currentAction">{{ 'ASSESSMENTAPP.RESPONSE.' + currentAction | translate }}</p>
									<p class="remove-margin text my-auto" *ngIf="currentQuestionSubtitle">{{'ASSESSMENTAPP.RESPONSE.' + currentQuestionSubtitle | translate }}</p>
								</div>
								
								<div [ngClass]="questionnaire.lang_code === 'he' ? 'me-auto' : 'ms-auto'" class="d-flex align-items-center gap-2" *ngIf="currentQuestion.response.response_type === 'VOICE'">
									<div *ngIf="showAutoRecordTimer" class="fs-16 text-danger">Auto recording will start in {{ recordAutoStartTimeRemaining }}</div> 
									<div *ngIf="!isRecorded" class="fs-24">{{ formatTime(record_timer) }}</div> 
									<button [disabled]="isRecorded" type="button" (click)="isRecording ? stopVoiceRecording() : startVoiceRecording()" [ngClass]="isRecording ? 'btn-danger' : isRecorded ? 'btn-primary' : 'btn-success'" class="d-flex btn personalDetailNextBtn questionaireNextBtn">
										{{ 'ASSESSMENTAPP.RESPONSE.' + (isRecording ? 'STOP' : isRecorded ? 'RECORDED' : 'RECORD') | translate }}
									</button>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="d-flex w-100 mt-2 justify-content-between ps-4 pe-4" *ngIf="currentQuestion.response.response_type === 'RANGE' && currentQuestion.response.response_range">
								<div class="radioBtnMain"
									*ngFor="let count of getNumbers(currentQuestion.response.response_range.range_min, currentQuestion.response.response_range.range_max); index as i">
									<div class="form-radio-outline form-radio-info d-flex justify-content-center">
										<input class="form-check-input" type="radio" name="formradiocolor14" placeholder="option"
										(change)="onRangeOptionSelected($event, count)" [checked]="selectedRangeOption === count">
									</div>
									<p class="m-0 mt-1 text-center">{{count}}</p>
									<p class="m-0 text-center" *ngIf="count === currentQuestion.response.response_range.range_min"> ({{ currentQuestion.response.response_range.range_label_min }})</p> 
									<p class="m-0 text-center" *ngIf="count === currentQuestion.response.response_range.range_max"> ({{ currentQuestion.response.response_range.range_label_max }})</p> 
								</div>
							</div>
		
							<div class="w-100 mt-2 justify-content-center ps-4 pe-4" *ngIf="currentQuestion.response.response_type === 'SELECT'">
								<div class="list-group" *ngIf="currentQuestion.response.response_select?.multi_select">
									<ng-container *ngFor="let option of currentQuestion.response.response_select?.response_options">
										<label class="list-group-item">
											<input class="form-check-input" [ngClass]="questionnaire.lang_code === 'he' ? 'ms-1' : 'me-1'" type="checkbox" [checked]="checkValueInSelectedOptionList(option)"
												(change)="onSelectResponseChange($event, option)">
												{{option.label}}
										</label>
									</ng-container>
								</div>
								<div class="list-group" *ngIf="!currentQuestion.response.response_select?.multi_select">
									<ng-container *ngFor="let option of currentQuestion.response.response_select?.response_options">
										<label class="list-group-item">
											<input class="form-check-input fs-14 mt-0 align-middle" [ngClass]="questionnaire.lang_code === 'he' ? 'ms-1' : 'me-1'" type="radio" [checked]="selectedOptions.length > 0 && (selectedOptions[0].label === option.label)"
												(change)="onSelectResponseChange($event, option)">
												{{option.label}}
										</label>
									</ng-container>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="justify-content-center align-items-center mt-3 mb-3" *ngIf="showVideoUploading">
				<div class="row text-center">
					<h5 style="color: #5b7ffc;" *ngIf="uploadInProgress">{{ 'ASSESSMENTAPP.UPLOADING' | translate }}<strong>{{ 'ASSESSMENTAPP.CLOSE_WINDOW' | translate }}</strong></h5>
				</div>
				<div *ngIf="uploadInProgress" class="row text-center">
					<circle-progress class="flex"
						[percent]="progressValue"
						[radius]="100"
						[outerStrokeWidth]="6"
						[showInnerStroke]="false"
						[outerStrokeColor]="'#5b7ffc'"
						[animation]="false"
						[showSubtitle]=false
						[titleColor]="'#5b7ffc'"
						[backgroundPadding] = 20
						[unitsColor]="'#5b7ffc'">
					</circle-progress>
				</div>
				<div class="row text-center" *ngIf="!uploadInProgress && pendingOfflineAnswersLen === 0">
					<h5 style="color: #5b7ffc;" class="flex">{{ 'ASSESSMENTAPP.UPLOADED' | translate }}</h5>
				</div>
				<div class="row text-center" *ngIf="!pendingOfflineAnswers && pendingOfflineAnswersLen > 0">
					<h5 class="flex text-danger">{{ 'ASSESSMENTAPP.SAVING_ANSWERS' | translate }} ({{ pendingOfflineAnswersLen }})</h5>
				</div>
			</div>
			<div *ngIf="!showVideoUploading" class="questionaireFooterBtn">
				<button [disabled]="!allowNext" (click)="nextQuestion()" type="button" class="d-flex btn btn-secondary personalDetailNextBtn mt-2" [ngClass]="questionnaire.lang_code === 'he' ? 'me-auto' : 'ms-auto'">{{ 'ASSESSMENTAPP.NEXT' | translate}}</button>
			</div>
		</div>
	</div>
</div>
<video #videoPlayer autoplay [muted]="true"></video>